<script lang="ts" setup>
import { useBasketStore } from '@/store/basket/basket'

const basketStore = useBasketStore()

const doNotCallMeBack = computed(() => {
  return basketStore.data.doNotCallMeBack
})

const changeDoNotCallMeBack = (value: boolean) => {
  // Отрицание значений, т.к. на бэке true - это не звонить
  basketStore.setDoNotCallMeBack(!value)
}
</script>

<template>
  <div class="call">
    <div class="call__top-container">
      <div class="call__title">Подтверждать заказ звонком</div>

      <the-switch
        :model-value="!doNotCallMeBack"
        @update:model-value="changeDoNotCallMeBack"
      />
    </div>

    <div class="call__description">
      Больше не нужно ждать звонка. Отключите подтверждение заказа звонком и мы
      сразу примем ваш заказ
    </div>
  </div>
</template>

<style scoped lang="scss">
.call {
  &__top-container {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 800;
    color: var(--ui-text-primary);

    @include media('<=tablet') {
      font-size: 14px;
    }
  }

  &__description {
    width: 100%;
    max-width: 414px;
    font-size: 14px;
    font-weight: 600;
    color: var(--ui-text-secondary);

    @include media('<tablet') {
      max-width: unset;
    }
  }
}
</style>
